import FormattedMessage from 'I18n/components/FormattedMessage';
import { LayoutBox } from 'breeze-intelligence-kit';
import { useDataTest } from './useDataTest/useDataTest';
import { BasePanel } from '../Panel/BasePanel';
import { jsx as _jsx } from "react/jsx-runtime";
export function DataTestPanelFooter() {
  const {
    enrichmentPolicy,
    isLoading,
    onEnrich,
    recordsEnrichable
  } = useDataTest();
  const hasEnrichableRecords = recordsEnrichable > 0;
  const isMainButtonDisabled = !enrichmentPolicy.accessEnrichment() || !hasEnrichableRecords;
  return /*#__PURE__*/_jsx(BasePanel.Footer, {
    children: /*#__PURE__*/_jsx(BasePanel.FooterActions, {
      alignItems: "center",
      blockSize: "100%",
      flexGrow: 1,
      justifyContent: "space-between",
      children: /*#__PURE__*/_jsx(BasePanel.FooterActions, {
        children: /*#__PURE__*/_jsx(LayoutBox, {
          flex: "0 0 auto",
          children: /*#__PURE__*/_jsx(BasePanel.ButtonUsageCheck, {
            action: "DATASET_ENRICHMENT",
            disabled: isMainButtonDisabled,
            isLoading: isLoading,
            numberOfOperations: recordsEnrichable,
            onClick: onEnrich,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "dataTest.panel.enrich"
            })
          })
        })
      })
    })
  });
}